import { CSSProperties } from "react"
import { C, radius, shadow } from "@/theme/newDesignTokens"
import { BRAND_NAME, LOGO_SRC } from "@/utils/brand"
import { t } from "i18next"

interface AuthUnavailableProps {
    onRetry: () => void
}

const styles: Record<string, CSSProperties> = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: C.pageBg,
        padding: 24,
    },
    card: {
        width: "100%",
        maxWidth: 480,
        padding: 48,
        textAlign: "center",
        backgroundColor: C.white,
        borderRadius: radius.xl,
        boxShadow: shadow.md,
    },
    logo: {
        height: 40,
        objectFit: "contain",
        marginBottom: 24,
    },
    heading: {
        margin: "0 0 12px",
        color: C.navyDark,
        fontSize: "1.5rem",
        fontWeight: 700,
    },
    status: {
        margin: 0,
        color: C.navyDark,
        fontSize: "0.95rem",
        lineHeight: 1.6,
    },
    button: {
        marginTop: 24,
        padding: "12px 32px",
        color: C.white,
        backgroundColor: C.navy,
        border: "none",
        borderRadius: radius.md,
        fontSize: 14,
        fontWeight: 600,
        cursor: "pointer",
    },
}

export function AuthUnavailable({ onRetry }: AuthUnavailableProps) {
    return (
        <main
            data-testid="auth-unavailable-page"
            style={styles.page}
            aria-labelledby="auth-unavailable-heading"
        >
            <section style={styles.card}>
                <img src={LOGO_SRC} alt={BRAND_NAME} style={styles.logo} />
                <h1 id="auth-unavailable-heading" style={styles.heading}>
                    {t("Sign-in unavailable")}
                </h1>
                <p style={styles.status} aria-live="polite">
                    {t(
                        "We could not connect to the sign-in service. Check your network connection and try again."
                    )}
                </p>
                <button type="button" style={styles.button} onClick={onRetry}>
                    {t("Retry")}
                </button>
            </section>
        </main>
    )
}

export default AuthUnavailable
